/* eslint-disable */

import React, { Component } from 'react';
import {
  Form,
  Button,
  Divider,
  TextArea,
  Grid,
  Loader,
  Icon,
  Dropdown
} from 'semantic-ui-react';
import { getAd } from '../../fbApi/Ad';

import { generateScreenshotsForAd } from '../../services/ScreenshotManager';
import './ScreenshotApi.css';

class ScreenshotApi extends Component {
  state = {
    form: {
      adId: ''
    },
    message: '',
    log: '',
    processing: false,
    imageIndex: 0,
    generatedImages: []
  };

  componentDidMount() {
    this.props.setSectionTitle('Screenshot API');
    this.props.saveGTMEvent('Screenshot API', 'Screenshot API');
  }

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };
  generateImages = async () => {
    this.setState({ log: '', message: '', imageIndex: 0, generatedImages: [] });

    const adId = this.state.form.adId;

    if (!adId) {
      this.setState({ message: 'You must enter an Ad Id' });
      return false;
    }

    this.setState({ processing: true });

    const ads = adId
      .split(',')
      .map((id) => ({
        adId: id,
        formats: ['DESKTOP_FEED_STANDARD', 'MOBILE_FEED_STANDARD']
      }));

    const result = await generateScreenshotsForAd(ads);
    console.warn('result', result);

    if (result.statusCode === 200 && result.generatedImages) {
      let log = this.state.log;
      const generatedImages = [];
      result.generatedImages.map((item) => {
        if (Array.isArray(item)) {
          item.forEach((image) => {
            generatedImages.push(image);
            log = `${log}Image: ${image.imageData.asset_location} CREATED for Ad Format ${image.imageData.format}\n`;
          });
        } else {
          log = `${log}Error: ${item.message}\n`;
        }
      });
      this.setState({ log, generatedImages });
    }

    this.setState({ processing: false });
  };

  generateImageUrl = () => {
    return (
      'https://s3.amazonaws.com/alexia-ad-assets/images/' +
      this.state.generatedImages[this.state.imageIndex].imageData.asset_location
    );
  };

  moveLeft = () => {
    if (this.state.imageIndex > 0) {
      this.setState({ imageIndex: this.state.imageIndex - 1 });
    }
  };

  moveRight = () => {
    if (this.state.imageIndex < this.state.generatedImages.length - 1) {
      this.setState({ imageIndex: this.state.imageIndex + 1 });
    }
  };

  renderGeneratedImages = () => {
    return (
      <div className="screenshot-images-container">
        <h3> Images Preview </h3>
        <label>
          <b>Ad Format: </b>
          {this.state.generatedImages[this.state.imageIndex].imageData.format}
        </label>
        <div className="screenshot-image-container">
          <img className="screenshot-image" src={this.generateImageUrl()} />
        </div>
        <div className="screenshot-counter-container">
          <label>
            Image {this.state.imageIndex + 1} from{' '}
            {this.state.generatedImages.length}
          </label>
        </div>
        <div className="screenshot-arrows-container">
          {this.state.imageIndex !== 0 ? (
            <a className="screenshot-arrow" onClick={this.moveLeft}>
              <Icon size="large" name="arrow alternate circle left" />
            </a>
          ) : (
            <Icon
              className="disabled-icon"
              size="large"
              name="arrow alternate circle left"
            />
          )}
          {this.state.imageIndex !== this.state.generatedImages.length - 1 ? (
            <a className="screenshot-arrow" onClick={this.moveRight}>
              <Icon size="large" name="arrow alternate circle right" />
            </a>
          ) : (
            <Icon
              className="disabled-icon"
              size="large"
              name="arrow alternate circle right"
            />
          )}
        </div>
      </div>
    );
  };

  render() {
    const { adId } = this.state.form;
    return (
      <div className="screenshot-container">
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <div className="screenshot-input-container">
                <Form.Input
                  placeholder="Ad Id"
                  type="text"
                  name="adId"
                  value={adId}
                  onChange={this.handleFormChange}
                />
                {this.state.message ? (
                  <label className="screenshot-error">
                    {this.state.message}
                  </label>
                ) : null}
                {this.state.processing ? (
                  <div className="screenshot-processing-container">
                    <Loader inline className="active" /> Processing...
                  </div>
                ) : null}
              </div>
              <Divider hidden />
              <Button onClick={this.generateImages} size="small" color="blue">
                Launch
              </Button>
              <Divider hidden />
              <TextArea
                className="debug-log"
                placeholder="Debug Log"
                disabled
                rows="20"
                cols="110"
                value={this.state.log}
              />
            </Grid.Column>
            <Grid.Column>
              {this.state.generatedImages.length > 0
                ? this.renderGeneratedImages()
                : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default ScreenshotApi;



// WEBPACK FOOTER //
// ./src/screens/Screenshot/ScreenshotApi.js